import React, {useState} from 'react';
import * as Yup from "yup";
import api from "@/services/api";
import { useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { TextField } from '@mui/material';
import { yupResolver } from "@hookform/resolvers/yup";
import ModalWrapperChildren from '@/views/components/Modal/ModalWrapperChildren';
import WithCharCount from '@/views/components/charCounter/charCounter';

const defaultValues = {
	content: '',
	textFragment: '',
};

const TextFieldWithCharCount = WithCharCount(TextField);

const ModalAddQuestion = ({setShowModalAdd, showModalAdd, editQuestion, getQuestion, setAlert, getQuestions}) => {
	const { dict, ppj } = useSelector(state => state.app);
	
	const [ requestIsPending, setRequestIsPending ] = useState(false);

	const validationSchema = Yup.object({
		content: Yup.string().required(dict.simpleTextAdvices.addQuestion.required).trim(),
	});

	const { handleSubmit, control, formState: { errors, isValid } } = useForm({
		resolver: yupResolver(validationSchema),
		defaultValues: editQuestion || defaultValues,
		reValidateMode: 'onChange',
		mode: 'onChange',
	});

	const handleClose = () => {
		// if (setItemToEdit) setItemToEdit(null);
		setShowModalAdd(false);
	};

	const handleFormSubmitUAM = async (data) => {
		submit(data, true);
	};

	const handleFormSubmit = async (data) => {
		submit(data, false);
	};

	const submit = async (data, isUAM) => {
		setRequestIsPending(true);
		try {
			let res = {};

			if(editQuestion) {
				res = await api.put(`/questions/${editQuestion.id}`, {content: data.content, textFragment: data.textFragment });

				if(res.status === 200) {

					if(isUAM) {
						const resUAM = await api.put(`/questions/${editQuestion.id}/send`, {content: data.content, textFragment: data.textFragment});
						if(resUAM.status === 200) {
							getQuestion(editQuestion.id);
							setAlert({content: dict.simpleTextAdvices.addQuestion.alert.uam, variant: 'success'});
						}
					} else {
						setShowModalAdd(false);
						getQuestion(editQuestion.id);
						setAlert({content: dict.simpleTextAdvices.addQuestion.alert.edit, variant: 'success'});
					}

				}
			} else {
				res = await api.post(`/questions`, data);
				if(res.status === 200) {
					setShowModalAdd(false);
					getQuestions();
					setAlert({content: dict.simpleTextAdvices.addQuestion.alert.add, variant: 'success'});
				}
			}

			if(res.status === 200) {
				setShowModalAdd(false);
				getQuestion(editQuestion.id);
			} 
		} catch (err) {
			// getErrors(err.response.data.errors);
		} finally {
			setRequestIsPending(false);
		}
	};

	return (
		<ModalWrapperChildren
			onClose={ handleClose }
			setModalVisible={ setShowModalAdd }
			modalVisible={ showModalAdd }
			onConfirm={ handleSubmit(handleFormSubmit) }
			onConfirm2={ handleSubmit(handleFormSubmitUAM) }
			closeButtonName={ dict.cancel }
			confirmButtonName={ editQuestion ? dict.simpleTextAdvices.addQuestion.editButton : dict.simpleTextAdvices.addQuestion.addLabel }
			confirmButtonName2={ ppj?.externalMode && editQuestion && dict.simpleTextAdvices.addQuestion.UAMButton }
			disabled={ !isValid }
			requestIsPending={ requestIsPending }
			//preTitle={ dict.simpleTextAdvices.addQuestion.preTitle }
			title={ editQuestion ? (
				<div className='modal-children__add-edit-title-container'>
					<span className='modal-children__add-edit-preTitle'>{ dict.simpleTextAdvices.addQuestion.preTitle }</span>
					<div className="modal-children__divider" />
					<span className='modal-children__add-edit-title'>{dict.simpleTextAdvices.addQuestion.editLabel}</span>
				</div>) : (
				<div className='modal-children__add-edit-title-container'>
					<span className='modal-children__add-edit-preTitle'>{ dict.simpleTextAdvices.addQuestion.preTitle }</span>
					<div className="modal-children__divider" />
					<span className='modal-children__add-edit-title'>{dict.simpleTextAdvices.addQuestion.askLabel}</span>
				</div>) }
			description={ editQuestion ? dict.simpleTextAdvices.addQuestion.descriptionEdit : dict.simpleTextAdvices.addQuestion.descriptionAdd }
			isLine
			requiredFields
		>
			<form onSubmit = { (e) => {
				e.preventDefault();
			} } >
				<label 
					className="modal-children__label"
					htmlFor='content'>
					{dict.simpleTextAdvices.addQuestion.textLabel}
				</label>
				<Controller
					render={ ({ field }) => <TextFieldWithCharCount
						size = 'small'
						fullWidth
						multiline
						maxRows = { 4 }
						placeholder = ""
						className='modal-children__count'
						{ ...field }	  
					/> }
					name={ 'content' }
					control={ control }
					errors={ errors.content }
				/>
				<p className="modal-children__error">{errors && errors.name && errors.name.message}</p>
				<label 
					className="modal-children__label"
					htmlFor='textFragment'>
					{dict.simpleTextAdvices.addQuestion.fragmentLabel}
				</label>
				<Controller
					render={ ({ field }) => <TextFieldWithCharCount
						size = 'small'
						fullWidth
						multiline
						maxRows = { 4 }
						placeholder = ""
						className='modal-children__count'
						maxCharCount = { 2000 }
						{ ...field }
					/> }
					name={ 'textFragment' }
					control={ control }
					errors={ errors.textFragment }
				/>
				<p className="modal-children__error">{errors && errors.textFragment && errors.textFragment.message}</p>
			</form>
		
		</ModalWrapperChildren>
	);
};

export default ModalAddQuestion;